// extracted by mini-css-extract-plugin
module.exports = {"btfcontent":"yizON","coronahomepage":"xEWva","text":"FRAbq","column":"XYnzQ","listing_v2":"W5_qr","coloured":"C_sNZ","disclamer":"glHNN","otherterms":"UHCm6","showless":"Lug6a"};